import TileType from '~/constants/TileType';
import type { ConditionalTile } from '~/contracts';

export type OwnProps = {
  hasSoftPull: boolean;
  showFinance: boolean;
};

export default function getFinanceTile({
  hasSoftPull,
  showFinance
}: OwnProps): ConditionalTile {
  return {
    active: showFinance && !hasSoftPull,
    index: 5,
    tileType: TileType.Finance
  };
}
